export default __webpack_public_path__ + "static/SR India - Safety Data Sheet - Caramel Color (Powder)-9e6385ed147b4ca69800da8fafc64523.pdf";